import React from "react"
import Imgix, { Background } from "react-imgix"
import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Helmet from "react-helmet"
import HeroBlock from "../components/hero-block"
import HomeBlock from "../components/home-block"
import SubheaderCovid from "../components/subheader-covid"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Carousel from "../components/carousel"
import Packages from "../components/packages"

import app from "../images/home/app.svg"
import install from "../images/home/install.svg"
import monitoring from "../images/home/monitoring.svg"
import network from "../images/home/network.svg"
import installation from "../images/home/installation.svg"

import startingAt from "../images/home/starting-at.svg"

const IndexPage = () => (

  <Layout className="home">
    <Helmet>
      <script type="application/ld+json">{`
      {
        "@context": "http://www.schema.org",
        "@type": "Organization",
        "name": "BrightSuite",
        "parentOrganization": "Dominion Energy, Inc.",
        "areaServed": "Virginia",
        "foundingDate": "2019",
        "foundingLocation": "Richmond, VA",
        "url": "https://www.brightsuite.com/",
        "logo": "https://shop.brightsuite.com/media/logo/stores/1/logo.png",
        "description": "We've paired the safety and reliability of our parent company, Dominion Energy, with the most innovative smart home and security products on the market, to bring you intelligent experiences that make life easier, safer, and more enjoyable.",
        "telephone": "(833) 374-8637",
        "email": "support@brightsuite.com",
        "sameAs": [
        "https://play.google.com/store/apps/details?id=com.alarm.alarmmobile.android.brightsuite&hl=en_US",
        "https://www.facebook.com/brightsuite/"
        ]
      }
    `}</script>
    </Helmet>
    <SEO title="Smart Home Security by Dominion Energy" />
    <SubheaderCovid />
    <HeroBlock
      body="Unlock your doors, adjust lights, play music and view cameras, plus enjoy 24/7 professional monitoring. It’s easy to put together just the right solution. With BrightSuite by Dominion Energy, the possibilities are brightly satisfying."
      image="home/home-hero-full.jpg"
      link="/popular/"
    >
      A Smart Home Backed by a Trusted Name
    </HeroBlock>


    <div className="module features">
      <div className="features__header ">If you find it satisfying when things work smoothly, you’ll like BrightSuite.</div>

      {/* <div className="features__desc t5">
        Simple smart home security to protect what matters most.
      </div> */}
      <Carousel className="features__container">
        <div className="feature">
          <img
            className="feature__image"
            src={network}
            alt="Reliable Network"
          />
          <div className="feature__header">Reliable Network</div>
          <div className="feature__desc t5">
          BrightSuite uses a cellular service so we’re always on even if your Wi-Fi isn’t.
          </div>
        </div>
        <div className="feature">
          <img
            className="feature__image"
            src={monitoring}
            alt="Reliable Network"
          />
          <div className="feature__header">24/7 Monitoring</div>
          <div className="feature__desc t5">
            We've partnered with the industry-leading 911 call center so that you're always protected.
          </div>
        </div>
        <div className="feature">
          <img
            className="feature__image"
            src={install}
            alt="Reliable Network"
          />
          <div className="feature__header">Easy Installation</div>
          <div className="feature__desc t5">
           Setup BrightSuite on your own, or have one of our professionals install the equipment for you.
          </div>
        </div>
        <div className="feature">
          <img
            className="feature__image"
            src={app}
            alt="Reliable Network" />
          <div className="feature__header">All In One App</div>
          <div className="feature__desc t5">
          Control your entire system from anywhere using your smartphone.
          </div>
        </div>
      </Carousel>
    </div>
    <div className="module possibilities">
      <div className="possibilities__container">
        <div className="details">
          <div className="price">
            <img className="price__image" src={startingAt} alt="Starting at" />
            <div className="price__text">$39/mo.</div>
          </div>
          <div className="headline_1">One Service.</div>
          <div className="headline_2">Endless possibilities.</div>
          <div className="body t5 t5--loose">
            Prevention, protection, and monitoring for what matters most – start your smart home here.
          </div>
          <Link to="/overview/" className="cta t7">
            Learn More
          </Link>
        </div>
        <div className="phone">
          <Imgix
            className="phone__actual"
            src="https://brightsuite.imgix.net/home/phone@2x.png"
            width={624}
            height={624}
            imgixParams={{ fit: "crop" }}
          />
        </div>
      </div>
    </div>
    <Packages
      header = "Three Satisfying Ways to Shop"
     />
    <div className="mb-10">
      <HomeBlock
        image="overview/build-your-bs.png"
        link="/about/"
      >
      <p className="purchase-about">About BrightSuite</p>
      </HomeBlock>
    </div>
  </Layout>
)

export default IndexPage
